// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 12px;
    margin: 16px 0 28px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 8px;
}
.pagination-btn{
    border: none;
    border-radius: 50px;
    min-width: 35px;
    width: 35px;
    height: 35px;
    flex: 0 0 auto;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.131);
    color: #004996;
    font-weight: bolder;
    background-color: #ffffff;
}

.pagination-btn.active, .pagination-btn:hover{
    background-color: #004996;
    color: #ffffff;
}

@media (max-width: 1024px) {
    .pagination {
        gap: 10px;
        margin-bottom: 20px;
    }
}

@media (max-width: 768px) {
    .pagination {
        flex-wrap: nowrap;
        justify-content: center;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 4px;
    }

    .pagination-btn {
        width: 34px;
        height: 34px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/pagination.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,cAAc;IACd,4CAA4C;IAC5C,cAAc;IACd,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI;QACI,SAAS;QACT,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,uBAAuB;QACvB,gBAAgB;QAChB,iCAAiC;QACjC,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".pagination{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin: 16px 0 28px;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 0 8px;\n}\n.pagination-btn{\n    border: none;\n    border-radius: 50px;\n    min-width: 35px;\n    width: 35px;\n    height: 35px;\n    flex: 0 0 auto;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.131);\n    color: #004996;\n    font-weight: bolder;\n    background-color: #ffffff;\n}\n\n.pagination-btn.active, .pagination-btn:hover{\n    background-color: #004996;\n    color: #ffffff;\n}\n\n@media (max-width: 1024px) {\n    .pagination {\n        gap: 10px;\n        margin-bottom: 20px;\n    }\n}\n\n@media (max-width: 768px) {\n    .pagination {\n        flex-wrap: nowrap;\n        justify-content: center;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n        padding-bottom: 4px;\n    }\n\n    .pagination-btn {\n        width: 34px;\n        height: 34px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
